export default {
  setNowOptions ({ commit }, nowOptions) {
    const items = nowOptions.map((item) => {
      return {
        value: item.id,
        text: item.value
      }
    })

    commit('setAttr', {
      name: 'nowOptions',
      value: items
    })
  }
}
